import { type FC } from 'react';

import { GenericModal } from '@shared/components/ui/custom';

import { CreateNewUserForm } from './CreateNewUser.form';

export const CreateNewUserModal: FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <GenericModal
      open
      title="Add New User"
      data-testid="add-new-user-modal"
      contentProps={{
        className: 'max-w-4xl w-full',
      }}
      onOpenChange={(open) => !open && onClose()}
    >
      <CreateNewUserForm />
    </GenericModal>
  );
};
